/*
 * The Template Studio zone text preview: which OCR words a zone captures.
 *
 * A word is in the zone when its CENTER is inside the zone, bounds inclusive.
 * This is the rule the extractor uses (capture-app templateExtractor
 * wordsInBox), so the preview shows the words extraction will capture. The
 * previous rule kept any word with more than 30 percent of its area inside,
 * which showed words that extraction then dropped at the zone edge.
 *
 * The boundary cases in zoneTextPreview.test.js are mirrored in capture-app
 * src/__tests__/templateExtractorZoneBoundary.test.ts; change both together.
 */

/**
 * @param {{x:number,y:number,w:number,h:number}} zone  normalized 0..1
 * @param {Array<{text:string,bbox:{x1:number,y1:number,x2:number,y2:number}}>} ocrWords
 * @returns {{text:string, wordCount:number, available:boolean}}
 */
export function computeZoneTextPreview(zone, ocrWords) {
  if (!zone || !ocrWords || !Array.isArray(ocrWords) || ocrWords.length === 0) {
    return { text: '', wordCount: 0, available: !!ocrWords };
  }
  const zx1 = zone.x, zy1 = zone.y;
  const zx2 = zone.x + zone.w, zy2 = zone.y + zone.h;

  const matched = [];
  for (const w of ocrWords) {
    const b = w.bbox;
    if (!b) continue;
    // word bbox: x1,y1 = top-left, x2,y2 = bottom-right (normalized 0..1)
    const cx = (b.x1 + b.x2) / 2;
    const cy = (b.y1 + b.y2) / 2;
    if (cx >= zx1 && cx <= zx2 && cy >= zy1 && cy <= zy2) {
      matched.push({ text: w.text, x: b.x1, y: b.y1 });
    }
  }
  // Sort by y then x (reading order)
  matched.sort((a, b) => {
    const dy = a.y - b.y;
    if (Math.abs(dy) > 0.005) return dy;
    return a.x - b.x;
  });
  return {
    text: matched.map(m => m.text).join(' '),
    wordCount: matched.length,
    available: true,
  };
}
